import React from 'react';
import styles from "./CapacityPieChart.module.scss";

const CapacityPieChart = ({ allocatedDisplaySize, usedFraction, primaryColor }) => {
    // In case of insignificant non-zero utilization, show visible color to indicate some usage:
    if (usedFraction > 0 && usedFraction < 0.005) usedFraction = 0.005;

    const size = 110; // px
    const radius = 50; // px
    const circumference = 2 * Math.PI * radius;

    return (<div className={styles['pie']} style={{ width: size, height: size }}>
        <svg width={size} height={size}>
            <circle className={styles['allocated-capacity']}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
            />
            <circle className={styles["disk-used-capacity"]}
                    style={{
                        stroke: primaryColor,
                        strokeDasharray: `${usedFraction * circumference},${(1 - usedFraction) * circumference}`
                    }}
                    r={radius}
                    cx={size / 2}
                    cy={size / 2}
            />
        </svg>
        <span className={styles['allocated']}>
            {allocatedDisplaySize}<br/><span>Provisioned</span>
        </span>
    </div>);
};

export default CapacityPieChart;
